import {createAction} from 'redux-act';

// Get onboarding data
export const GET_BYOC_ONBOARDING_DATA = createAction(
  'byocOnboarding/GET_BYOC_ONBOARDING_DATA'
);
export const GET_BYOC_ONBOARDING_DATA_SUCCESS = createAction(
  'byocOnboarding/GET_BYOC_ONBOARDING_DATA_SUCCESS'
);
export const GET_BYOC_ONBOARDING_DATA_ERROR = createAction(
  'byocOnboarding/GET_BYOC_ONBOARDING_DATA_ERROR'
);

// Save Signup step
export const SAVE_BYOC_SIGNUP = createAction('byocOnboarding/SAVE_BYOC_SIGNUP');
export const SAVE_BYOC_SIGNUP_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_SIGNUP_SUCCESS'
);
export const SAVE_BYOC_SIGNUP_ERROR = createAction(
  'byocOnboarding/SAVE_BYOC_SIGNUP_ERROR'
);

// Save Signature
export const SAVE_BYOC_SIGNATURE = createAction(
  'byocOnboarding/SAVE_BYOC_SIGNATURE'
);
export const SAVE_BYOC_SIGNATURE_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_SIGNATURE_SUCCESS'
);
export const SAVE_BYOC_SIGNATURE_ERROR = createAction(
  'byocOnboarding/SAVE_BYOC_SIGNATURE_ERROR'
);

// Save MenuSetup step
export const SAVE_BYOC_MENU_SETUP = createAction(
  'byocOnboarding/SAVE_BYOC_MENU_SETUP'
);
export const SAVE_BYOC_MENU_SETUP_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_MENU_SETUP_SUCCESS'
);
export const SAVE_BYOC_MENU_SETUP_ERROR = createAction(
  'byocOnboarding/SAVE_BYOC_MENU_SETUP_ERROR'
);

// Save Adjustment Price Rules
export const SAVE_BYOC_ADJUSTMENT_PRICE_RULES = createAction(
  'byocOnboarding/SAVE_BYOC_ADJUSTMENT_PRICE_RULES'
);
export const SAVE_BYOC_ADJUSTMENT_PRICE_RULES_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_ADJUSTMENT_PRICE_RULES_SUCCESS'
);
export const SAVE_BYOC_ADJUSTMENT_PRICE_RULES_ERROR = createAction(
  'byocOnboarding/SAVE_BYOC_ADJUSTMENT_PRICE_RULES_ERROR'
);

// Save OrderSourceIntegration step
export const SAVE_BYOC_ORDER_SOURCE_INTEGRATION = createAction(
  'byocOnboarding/SAVE_BYOC_ORDER_SOURCE_INTEGRATION'
);
export const SAVE_BYOC_ORDER_SOURCE_INTEGRATION_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_ORDER_SOURCE_INTEGRATION_SUCCESS'
);
export const SAVE_BYOC_ORDER_SOURCE_INTEGRATION_ERROR = createAction(
  'byocOnboarding/SAVE_BYOC_ORDER_SOURCE_INTEGRATION_ERROR'
);

// Save PaymentDetails step
export const SAVE_BYOC_PAYMENT_DETAILS = createAction(
  'byocOnboarding/SAVE_BYOC_PAYMENT_DETAILS'
);
export const SAVE_BYOC_PAYMENT_DETAILS_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_PAYMENT_DETAILS_SUCCESS'
);
export const SAVE_BYOC_PAYMENT_DETAILS_ERROR = createAction(
  'byocOnboarding/SAVE_BYOC_PAYMENT_DETAILS_ERROR'
);

export const SAVE_BYOC_STRIPE_FLOW_COMPLETED = createAction(
  'byocOnboarding/SAVE_BYOC_STRIPE_FLOW_COMPLETED'
);
export const SAVE_BYOC_STRIPE_FLOW_COMPLETED_SUCCESS = createAction(
  'byocOnboarding/SAVE_BYOC_STRIPE_FLOW_COMPLETED_SUCCESS'
);

// Update IsConnectedToPos
export const UPDATE_BYOC_IS_CONNECTED_TO_POS = createAction(
  'byocOnboarding/UPDATE_BYOC_IS_CONNECTED_TO_POS'
);
export const UPDATE_BYOC_IS_CONNECTED_TO_POS_SUCCESS = createAction(
  'byocOnboarding/UPDATE_BYOC_IS_CONNECTED_TO_POS_SUCCESS'
);
export const UPDATE_BYOC_IS_CONNECTED_TO_POS_ERROR = createAction(
  'byocOnboarding/UPDATE_BYOC_IS_CONNECTED_TO_POS_ERROR'
);

// Get Agreement - multiple requests
export const GET_BYOC_AGREEMENT = createAction(
  'byocOnboarding/GET_BYOC_AGREEMENT'
);
export const GET_BYOC_AGREEMENT_SUCCESS = createAction(
  'byocOnboarding/GET_BYOC_AGREEMENT_SUCCESS'
);
export const GET_BYOC_AGREEMENT_ERROR = createAction(
  'byocOnboarding/GET_BYOC_AGREEMENT_ERROR'
);

// Mark Order Source Integration as finished
export const MARK_BYOC_ORDER_SOURCE_FINISHED = createAction(
  'byocOnboarding/MARK_BYOC_ORDER_SOURCE_FINISHED'
);
export const MARK_BYOC_ORDER_SOURCE_FINISHED_SUCCESS = createAction(
  'byocOnboarding/MARK_BYOC_ORDER_SOURCE_FINISHED_SUCCESS'
);
export const MARK_BYOC_ORDER_SOURCE_FINISHED_ERROR = createAction(
  'byocOnboarding/MARK_BYOC_ORDER_SOURCE_FINISHED_ERROR'
);

// Update onboarding step - new unified PATCH endpoint
export const UPDATE_BYOC_ONBOARDING_STEP = createAction(
  'byocOnboarding/UPDATE_BYOC_ONBOARDING_STEP'
);
export const UPDATE_BYOC_ONBOARDING_STEP_SUCCESS = createAction(
  'byocOnboarding/UPDATE_BYOC_ONBOARDING_STEP_SUCCESS'
);
export const UPDATE_BYOC_ONBOARDING_STEP_ERROR = createAction(
  'byocOnboarding/UPDATE_BYOC_ONBOARDING_STEP_ERROR'
);

export const UPDATE_BYOC_COMMISSION_STATE = createAction(
  'byocOnboarding/UPDATE_BYOC_COMMISSION_STATE'
);

// Clear data
export const CLEAR_BYOC_ONBOARDING_DATA = createAction(
  'byocOnboarding/CLEAR_BYOC_ONBOARDING_DATA'
);
